<template>
  <v-row justify="end">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" width="520">
      <template #activator="{ props }">
        <v-btn
          dark
          class="button-config"
          v-bind="props"
          style="background-color: #004984"
        >
          Convidar Usuário
          <v-icon right style="margin-left: 5px">mdi-account-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Convidar Usuário</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-for="n in numeroUsuarios"
                :key="n"
                cols="12"
                style="padding: 0"
              >
                <v-expansion-panels>
                  <v-expansion-panel
                    :title="`Usuário ${n} ${
                      usernames[n - 1].name ? '- ' + usernames[n - 1].name : ''
                    }`"
                  >
                    <v-expansion-panel-text>
                      <v-text-field
                        v-model="usernames[n - 1].name"
                        label="Username do GitHub*"
                        variant="underlined"
                        required
                      ></v-text-field>
                      <v-select
                        v-model="equipesSelecionadas[n - 1]"
                        :items="equipes"
                        item-title="nome"
                        label="Equipe"
                        variant="underlined"
                        v-if="!usernames[n - 1].coordenadorFlag"
                        item-value="id"
                        required
                      ></v-select>
                      <v-select
                        v-model="usernames[n - 1].formaAtuacao"
                        :items="formasAtuacao"
                        label="Forma de Atuação"
                        variant="underlined"
                        v-if="!usernames[n - 1].coordenadorFlag"
                        required
                      ></v-select>
                      <v-checkbox
                        v-model="usernames[n - 1].coordenadorFlag"
                        density="compact"
                        class="small-checkbox"
                        label="Coordenador"
                      ></v-checkbox>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="addNumUser()"
            prepend-icon="mdi-plus"
          />
          <v-btn color="blue-darken-1" variant="text" @click="close">
            Cancelar
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="sendInvite">
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  data: () => ({
    dialog: false,
    usernames: [
      { name: null, coordenadorFlag: false, equipe: null, formaAtuacao: null },
    ],
    numeroUsuarios: 1,
    equipes: [],
    nomesEquipes: [],
    formasAtuacao: [
      'DESENVOLVEDOR',
      'SCRUM_MASTER',
      'TESTADOR',
      'PRODUCT_OWNER',
    ],
    equipesSelecionadas: [],
  }),
  components: {
    SnackBar,
  },
  created() {
    this.fetchEquipes();
  },
  methods: {
    /**
     * Incrementa o número de usuários que serão convidados.
     *
     * @function addNumUser
     * @returns {void}
     */
    addNumUser() {
      this.usernames.push({ name: null, coordenadorFlag: false });
      this.numeroUsuarios++;
    },
    /**
     * Realiza uma operação que fecha o modal de convidar usuários.
     *
     * @function close
     * @returns {void}
     */
    close() {
      this.dialog = false;
      // this.usernames = [];
      this.numeroUsuarios = 1;
    },
    /**
     * Envia um convite para o usuário com o nome de usuário informado.
     * O link do convite é aberto em uma nova janela.
     *
     * @function sendInvite
     * @returns {void}
     */
    sendInvite() {
      console.log(this.equipesSelecionadas);
      /*eslint-disable*/
      const convidadosData = {
        dados: this.usernames.map((user, index) => ({
          name: user.name,
          coordenadorFlag: user.coordenadorFlag,
          equipe: this.equipesSelecionadas[index],
          forma_atuacao: user.formaAtuacao,
        })),
        /* eslint-enable */
      };

      console.log(convidadosData);

      axios
        .post(API_URL + '/coordenador/convida/', convidadosData, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            response.data.msg,
          );
        })
        .catch((error) => {
          console.error(error.response.data);
          if (error.response.status === 404) {
            this.$refs.snackbar.showWarningSnackbar(
              'Informação',
              error.response.data.msg,
            );
          } else {
            this.$refs.snackbar.showErrorSnackbar(
              'Hm... Algo deu errado',
              'Por algum motivo, não conseguimos realizar sua associação!',
            );
          }
        });
      this.dialog = false;
    },

    /**
     * Faz uma requisição HTTP para buscar as equipes cadastradas no sistema.
     * @function fetchEquipes
     * @returns {void}
     */
    fetchEquipes() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .get(API_URL + '/equipes', config)
        .then((response) => {
          this.equipes = response.data.map((equipe) => ({
            id: equipe.id_equipe,
            nome: equipe.nome_equipe,
          }));
          this.nomesEquipes = this.equipes.map((equipe) => equipe.nome);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.button-config {
  background-color: #004984;
  text-transform: capitalize;
}
.small-checkbox {
  font-size: 12px;
}
</style>
